export const GET_SETTINGS_REQUEST = 'profile/GET_SETTINGS_REQUEST';
export const GET_SETTINGS_FAILURE = 'profile/GET_SETTINGS_FAILURE';
export const GET_SETTINGS_SUCCESS = 'profile/GET_SETTINGS_SUCCESS';

export const SAVE_SETTINGS_REQUEST = 'profile/SAVE_SETTINGS_REQUEST';
export const SAVE_SETTINGS_FAILURE = 'profile/SAVE_SETTINGS_FAILURE';
export const SAVE_SETTINGS_SUCCESS = 'profile/SAVE_SETTINGS_SUCCESS';



// WEBPACK FOOTER //
// ./src/containers/Settings/constants.js